module.exports = new __parcel__URL__("pipeline.e62196f9.jpg").toString();